import { render, staticRenderFns } from "./SelectBatchSetup.vue?vue&type=template&id=608b3750"
import script from "./SelectBatchSetup.vue?vue&type=script&lang=ts"
export * from "./SelectBatchSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports